import {
  CheckCircle,
  DollarSign,
  Settings,
  Star,
  XCircle,
  type LucideIcon,
} from 'lucide-react';
import type { ContradictionRuleType } from '../../../services/api/types.gen';

/** Placeholder lucide map until Christine's final icon set lands. */
const RULE_TYPE_ICONS: Record<ContradictionRuleType, LucideIcon> = {
  coding_oasis_error: XCircle,
  reimbursement_impact: DollarSign,
  star_rating_impact: Star,
  vbp_impact: CheckCircle,
  process_measure_impact: Settings,
};

const RULE_TYPE_LABELS: Record<ContradictionRuleType, string> = {
  coding_oasis_error: 'Coding / OASIS error',
  reimbursement_impact: 'Reimbursement impact',
  star_rating_impact: 'Star rating impact',
  vbp_impact: 'VBP impact',
  process_measure_impact: 'Process measure impact',
};

export function ContradictionRuleTypeIcon({
  type,
  className = 'h-3.5 w-3.5',
}: {
  type: ContradictionRuleType;
  className?: string;
}) {
  const Icon = RULE_TYPE_ICONS[type] ?? XCircle;
  const label = RULE_TYPE_LABELS[type] ?? type;
  return (
    <span title={label}>
      <Icon className={className} aria-label={label} />
    </span>
  );
}
